import { render, staticRenderFns } from "./repayment.vue?vue&type=template&id=64823a2f&scoped=true"
import script from "./repayment.vue?vue&type=script&lang=js"
export * from "./repayment.vue?vue&type=script&lang=js"
import style0 from "./repayment.vue?vue&type=style&index=0&id=64823a2f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64823a2f",
  null
  
)

export default component.exports